import { Children, cloneElement, HTMLAttributes, isValidElement, ReactNode } from 'react';
import { handleKeyboardClick } from 'utils/accessibility';

interface GridProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
    firstChildClassName?: string;
    lastChildClassName?: string;
    middleChildClassName?: string;
}

export const Grid = ({ children, className, firstChildClassName = '', lastChildClassName = '', middleChildClassName = '', ...rest }: GridProps) => {
    const ChildrenArray = Children.toArray(children);
    return (
        <>
            {ChildrenArray.map((child, index) => {
                if (isValidElement(child)) {
                    return cloneElement(child, {
                        ...rest,
                        className: `${child.props.className ?? ''} ${className} ${index === 0 ? firstChildClassName : ''} ${
                            index === ChildrenArray.length - 1 ? lastChildClassName : ''
                        } ${index !== 0 && index !== ChildrenArray.length - 1 ? middleChildClassName : ''}
            `,
                    });
                }
                return child;
            })}
        </>
    );
};

interface GridHeaderProps {
    children: ReactNode;
}

/** Grid header row with gray background and smaller text */
const GridHeader = ({ children }: GridHeaderProps) => (
    <Grid
        className='py-1 text-sm font-semibold text-gray-500 bg-gray-100'
        firstChildClassName='pl-2 text-left'
        middleChildClassName='text-right '
        lastChildClassName='text-right pr-2'>
        {children}
    </Grid>
);
Grid.Header = GridHeader;


const GridRow = ({ children, onClick, className, ...rest }: GridProps) => {
    const isClickable = !!onClick;
    
    return (
        <Grid
            firstChildClassName='ml-2 text-left'
            middleChildClassName='text-right pl-2'
            lastChildClassName='text-right mr-2'
            onClick={onClick}
            role={isClickable ? 'button' : undefined}
            tabIndex={isClickable ? 0 : undefined}
            onKeyDown={isClickable ? handleKeyboardClick(() => onClick?.({} as React.MouseEvent<HTMLDivElement>)) : undefined}
            className={`${className || ''} ${isClickable ? 'cursor-pointer focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-yellow-400 focus-visible:ring-offset-2' : ''}`}
            {...rest}>
            {children}
        </Grid>
    );
};
Grid.Row = GridRow;
